import React, { createContext, useContext, useEffect, useState } from "react";
import { fakeLogin, fakeLogout, fakeSignup, getSavedUser } from "./fakeAuthApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);
  const [authLoading, setAuthLoading] = useState(false);
  const [authError, setAuthError] = useState("");

  useEffect(() => {
    const saved = getSavedUser();
    if (saved) setUser(saved);
    setInitializing(false);
  }, []);

  const login = async (email, password) => {
    setAuthError("");
    setAuthLoading(true);
    try {
      const u = await fakeLogin({ email, password });
      setUser(u);
      return u;
    } catch (err) {
      setAuthError(err.message || "Login failed.");
      throw err;
    } finally {
      setAuthLoading(false);
    }
  };

  const signup = async (name, email, password) => {
    setAuthError("");
    setAuthLoading(true);
    try {
      const u = await fakeSignup({ name, email, password });
      setUser(u);
      return u;
    } catch (err) {
      setAuthError(err.message || "Signup failed.");
      throw err;
    } finally {
      setAuthLoading(false);
    }
  };

  const logout = async () => {
    setAuthLoading(true);
    try {
      await fakeLogout();
      localStorage.removeItem("ubp_demo_user");
      setUser(null);
    } finally {
      setAuthLoading(false);
    }
  };

  const value = {
    user,
    isAuthenticated: !!user,
    initializing,
    authLoading,
    authError,
    login,
    signup,
    logout,
    setAuthError,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
